var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.theme],attrs:{"id":"app"}},[(!_vm.$route.path.includes('/headphones/quiet-comfort-earbud'))?_c('promo-section'):_vm._e(),_c('main-navigation',{class:{
      'products-page-nav': _vm.$route.path.includes(
        '/headphones/quiet-comfort-earbud'
      ),
    }}),(_vm.$route.path.includes('/products/headphones/'))?_c('product-nav'):_vm._e(),_c('router-view'),_c('mainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }